import { ingridCheckoutApi } from './checkout'

export const ingridApi = {
  checkout: ingridCheckoutApi
}
